export default __webpack_public_path__ + "static/media/danceofdeath.6223ac09.png";